import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "stalled"
}
const _hoisted_2 = { class: "bet-info" }
const _hoisted_3 = { class: "amount penalty-amount" }
const _hoisted_4 = { class: "bet-actions" }
const _hoisted_5 = ["disabled", "title", "onClick"]
const _hoisted_6 = ["disabled", "title", "onClick"]
const _hoisted_7 = { class: "bet-info" }
const _hoisted_8 = { class: "amount" }
const _hoisted_9 = ["disabled", "title", "onClick"]
const _hoisted_10 = {
  key: 0,
  class: "msg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.bets.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "stalled-head" }, [
          _createElementVNode("span", { class: "title" }, "⚠ Reclaim stalled bets"),
          _createElementVNode("span", { class: "sub" }, "A game didn't resolve — reclaim your escrowed stake trustlessly. Auto-claims at expiry; manual buttons stay as a backup.")
        ], -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bets, (b) => {
          return (_openBlock(), _createElementBlock("div", {
            key: b.gameId,
            class: "bet-row"
          }, [
            (_ctx.hasForfeit(b))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", _hoisted_3, "Claim full pot — " + _toDisplayString(b.tier.toLocaleString()) + " sats (your stake + house)", 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["state", { ready: _ctx.isForfeitReady(b), auto: _ctx.isAutoClaiming(b) }])
                    }, _toDisplayString(_ctx.forfeitStatusLabel(b)), 3),
                    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "penalty-note" }, "The house didn't reveal its secret. Forfeit kicks in — you take everything.", -1))
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("button", {
                      class: "claim-btn",
                      disabled: !_ctx.isForfeitReady(b) || _ctx.isClaiming(b),
                      title: _ctx.isForfeitReady(b) ? '' : _ctx.forfeitStatusLabel(b),
                      onClick: ($event: any) => (_ctx.claimForfeit(b.gameId))
                    }, _toDisplayString(_ctx.claimBtnLabel(b, 'forfeit')), 9, _hoisted_5),
                    _createElementVNode("button", {
                      class: "reclaim-link",
                      disabled: !_ctx.isReady(b) || _ctx.isClaiming(b),
                      title: _ctx.isReady(b) ? '' : _ctx.statusLabel(b),
                      onClick: ($event: any) => (_ctx.reclaim(b.gameId))
                    }, _toDisplayString(_ctx.claimBtnLabel(b, 'refund-link')), 9, _hoisted_6)
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(b.tier.toLocaleString()) + " sats", 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["state", { ready: _ctx.isReady(b), auto: _ctx.isAutoClaiming(b) }])
                    }, _toDisplayString(_ctx.statusLabel(b)), 3)
                  ]),
                  _createElementVNode("button", {
                    class: "reclaim-btn",
                    disabled: !_ctx.isReady(b) || _ctx.isClaiming(b),
                    title: _ctx.isReady(b) ? '' : _ctx.statusLabel(b),
                    onClick: ($event: any) => (_ctx.reclaim(b.gameId))
                  }, _toDisplayString(_ctx.claimBtnLabel(b, 'refund')), 9, _hoisted_9)
                ], 64))
          ]))
        }), 128)),
        (_ctx.message)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.message), 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}